import { render, staticRenderFns } from "./SaveForNextTime.vue?vue&type=template&id=0632a3d4"
import script from "./SaveForNextTime.vue?vue&type=script&lang=ts"
export * from "./SaveForNextTime.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports